import React from 'react'
import CampaignProgrammaticSummary from '../summary/ProgrammaticCampaignSummary'
import FadeWrapper from '../../../components/transitions/FadeWrapper'
import { PageContent } from '../../../components/layout/PageContent'
import Stats from './stats/Stats'
import { Box } from '@mui/material'

const CampaignProgrammatic: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        overflow: 'auto',
        flex: 1,
      }}
    >
      <FadeWrapper>
        <PageContent>
          <CampaignProgrammaticSummary />
          <Stats />
        </PageContent>
      </FadeWrapper>
    </Box>
  )
}

export default CampaignProgrammatic
